import React from 'react';
import styles from '../css/vdr.module.css';

const RelatedIrlObsPanel = ({ mode = 'related_irl', items = [], onOpen }) => {
    const isIrl = mode === 'related_irl';

    return (
        <div>
            {items.map(item => {
                const statusLower = String(item.status || '').toLowerCase();
                const statusClass = statusLower === 'answered' ? styles.statusAnswered : styles.listItemMeta;

                return (
                    <div key={item.id} className={styles.listItem}>
                        <div className={styles.relatedItemRow}>
                            <div>
                                {isIrl ? (
                                    <div className={styles.irlId}>{String(item.label || item.id)}</div>
                                ) : (
                                    <span className={styles.obsBadge}>{String(item.label || item.id)}</span>
                                )}
                                <div className={styles.listItemTitle} style={{ marginTop: 6 }}>
                                    {item.title}
                                </div>
                                {isIrl ? (
                                    <div className={statusClass} style={{ marginTop: 2 }}>
                                        {item.status || '—'}
                                    </div>
                                ) : (
                                    <div className={styles.listItemMeta} style={{ marginTop: 2 }}>
                                        {item.description || '—'}
                                    </div>
                                )}
                            </div>
                            <button type="button" className={styles.textLink} onClick={() => onOpen?.(item)}>
                                Open →
                            </button>
                        </div>
                    </div>
                );
            })}
            {items.length === 0 ? <p className={styles.subMeta}>No related items</p> : null}
        </div>
    );
};

export default RelatedIrlObsPanel;
